import { useQuery } from '@tanstack/react-query';
import { useInstituteService } from '../../../../apis/institute/useInstituteService';

export const useInstituteLeavesHook = () => {
  const { getInstituteLeaves } = useInstituteService();
  return useQuery({
    queryKey: ['instituteLeaves'],
    queryFn: getInstituteLeaves,
  });
};
